import React from 'react';
import FilterHoverTip from './FilterHoverTip';

interface IHookSafeRendererProps extends IBaseProps {
  hoverTip?: React.ReactNode;
  renderProps: any;
  renderFn: (props: any) => React.ReactElement | null;
}

const HookSafeRenderer: React.FC<IHookSafeRendererProps> = (props) => {
  const { hoverTip, renderProps, renderFn } = props;

  const rendered = renderFn(renderProps);
  if (!rendered) {
    return null;
  }
  if (hoverTip) {
    return <FilterHoverTip hoverTip={hoverTip}>{rendered}</FilterHoverTip>;
  }
  return rendered;
};

export default HookSafeRenderer;
